import list from './list'
import details from './details'
import active from './active'
import template from './template'
import failed from './failed'

export default { list, details, active, template, failed }
